import React, { useEffect, useState } from 'react';
import { dashboardpagesProps } from './dashboardpages-interface';
import { Layout, Input, Select, Dropdown, Tooltip } from 'antd';
import moment from 'moment';
import { routes, teacherRoutes } from '../../utils/routes';
import type { MenuProps } from 'antd';
import Reviewmodal from './reviewmodal/reviewmodal';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser, updateUser } from '../../store/userSlice/userSlice';
import Appsearch from './appsearch/appsearch';
import { RootState } from '../../store/store';
import { getAIAssignment } from '../../api/ai/aitutor';
import Aialerts from './aialerts/aialerts';
import Aiwidget from './aiwidget/aiwidget';
import { findDashboardRef, sortNewChat } from '../../utils/helper';
import Aimessaging from './aimessaging/aimessaging';
import { updateShowTourStart } from '../../store/appSlice/appSlice';
import NotificationMenu from './notifications/notificationMenu';
import useChats from '../../customhooks/useChats/useChats';
import { REACT_APP_WEB_SOCKET_URL } from '../../utils/appdetails';
import { connectChatSocket } from '../../store/webSocketSlice/socketThunks';
import { selectChatSocket } from '../../store/webSocketSlice/webSocketSlice';
import { setNewChat } from '../../store/chatSlice/chatSlice';

const { Header, Content, Sider } = Layout;
const { Option } = Select;

const Dashboardpages = ({
  children,
  showHeader,
  refs,
  currentTourNumber,
}: dashboardpagesProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  useChats();

  const [collapseSideBar, setCollapseSideBar] = useState(false);
  const [aiAlertMessage, setAiAlertMessage] = useState({
    title: '',
    description: '',
  });
  const [aiAlertType, setAiAlertType] = useState<
    'error' | 'warning' | 'success' | null
  >(null);
  const [showAIAlert, setShowAIAlert] = useState(false);
  const [showAppSearch, setShowAppSearch] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showAIOptions, setShowAIOptions] = useState(false);
  const [showAIMessageScreen, setShowAIMessageScreen] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false);

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
    showTour: state.app.showTour,
  }));

  const chatSocket = useSelector(selectChatSocket);

  const { user, showTour } = state;

  const closeAIAlert = () => {
    setShowAIAlert(false);
    setAiAlertMessage({
      title: '',
      description: '',
    });
    setAiAlertType(null);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeReviewModal = () => {
    setShowReviewModal(false);
  };

  const closeAppSearch = () => {
    setShowAppSearch(false);
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a
          rel='noopener noreferrer'
          href='/'
          onClick={(e) => {
            e.preventDefault();
            navigate(`/${user?.userType}/dashboard/profile`);
          }}>
          Profile
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a
          rel='noopener noreferrer'
          href='/'
          onClick={(e) => {
            e.preventDefault();
            dispatch(logoutUser());
            navigate('/login');
          }}>
          Logout
        </a>
      ),
    },
  ];

  const getAiAssignmentDetails = async () => {
    try {
      const res = await getAIAssignment(user?._id);
      const { data } = res.data;

      dispatch(
        updateUser({
          user: {
            ...user,
            aiTutorAssignmentId: data?._id,
            aiTutorDetails: data?.aiId,
          },
        })
      );
    } catch (error) {}
  };

  // const runCheckClasses = async () => {
  // 	try {
  // 		const res = await getAIAssignmentJoinClassCheck(user?.aiTutorAssignmentId)
  // 		const { message } = res.data
  // 		if (message !== undefined) {
  // 			setShowAIAlert(false)
  // 			setAiAlertMessage(message)
  // 			setAiAlertType('warning')
  // 		}
  // 	} catch (error) {
  // 	}
  // }

  useEffect(() => {
    const isLoggedIn = !!user?._id;

    if (!isLoggedIn) {
      navigate('/login');
    }
  }, [user]);

  useEffect(() => {
    if (showTour) {
      if (currentTourNumber === 1) {
        setShowAIOptions(true);
      } else {
        setShowAIOptions(false);
      }
    }

    // eslint-disable-next-line
  }, [currentTourNumber]);

  useEffect(() => {
    if (showTour === false && showAIOptions) {
      setShowAIOptions(false);
    }

    // eslint-disable-next-line
  }, [showTour]);

  useEffect(() => {
    if (
      user?.aiTutorAssignmentId === undefined ||
      user?.aiTutorDetails === undefined
    ) {
      getAiAssignmentDetails();
    }

    if (user?.shouldReviewApp) {
      setShowReviewModal(true);
    }

    // eslint-disable-next-line
  }, []);

  // initializing chat socket
  React.useEffect(() => {
    dispatch(
      connectChatSocket(`${REACT_APP_WEB_SOCKET_URL}/chat` || '') as any
    );

    if (chatSocket) {
      return () => {
        chatSocket.disconnect(); // Disconnect the socket when the component unmounts
      };
    }
  }, [dispatch]);

  React.useEffect(() => {
    if (!chatSocket) return;

    // join chat notification room
    chatSocket.emit('join_chat_rooms', user?._id);

    // listen for new messages
    chatSocket.on('newMessage', (data: any) => {
      // receiving identifier with new chat message
      dispatch(
        setNewChat(
          sortNewChat(
            {
              ...data,
              identifier: data?.identifier,
            },
            user?._id
          )
        )
      );
    });

    // listen for new chats
    chatSocket.on('newChat', (data: any) => {
      // receiving identifier with new chat message
      dispatch(
        setNewChat(
          sortNewChat(
            {
              ...data,
            },
            user?._id
          )
        )
      );

      // join chat notification room
      chatSocket.emit('join_chat_rooms', user?._id, data?._id);
    });

    return () => {
      chatSocket.off('newChat');
    };
  }, [chatSocket, dispatch, user?._id]);

  // useEffect(() => {
  // 	if (user?.aiTutorAssignmentId !== undefined) {
  // 		runCheckClasses()
  // 	}

  // }, [])

  const openAIAlert = (notification: any) => {
    setShowAIAlert(true);
    setAiAlertMessage({
      title: notification.title,
      description: notification.description,
    });
    setAiAlertType('warning');
  };

  useEffect(() => {
    if (location.pathname.includes('/ide')) {
      setCollapseSideBar(true);
    }
  }, [location]);

  return (
    <div className='relative'>
      {showAppSearch ? (
        <Appsearch open={showAppSearch} closeModal={closeAppSearch} />
      ) : null}

      {
        // showAIOptions ?
        <Aiwidget
          setShowAIOptions={setShowAIOptions}
          showAIOptions={showAIOptions}
          ref={
            refs !== undefined ? findDashboardRef(refs, 'openLily') : undefined
          }
          updateShowAIMessageScreen={(value: boolean) => {
            setShowAIMessageScreen(value);
          }}
          showAIMessageScreen={showAIMessageScreen}
          openAIAlert={openAIAlert}
        />
        // : null
      }

      {showAIMessageScreen ? (
        <Aimessaging
          updateShowAIMessageScreen={(value: boolean) => {
            setShowAIMessageScreen(value);
          }}
        />
      ) : null}

      <Layout hasSider className='relative'>
        <Sider
          style={{
            overflow: 'auto',
            height: '100vh',
            position: 'fixed',
            left: 0,
            top: 0,
            bottom: 0,
          }}
          className={`custom-primary-bg-one dash-side-bar ${
            !collapseSideBar ? '' : 'collapse-side-bar'
          }`}>
          <div className='relative h-full'>
            <div
              className='my-[3.2rem] mt-[1.6rem] flex cursor-pointer justify-center'
              onClick={() => {
                navigate(`/${user?.userType.toLowerCase()}/dashboard`);
              }}>
              {!collapseSideBar ? (
                <img src='/img/logo/logo.svg' alt='logo' />
              ) : (
                <img src='/img/logo/cfhcircle.svg' alt='logo' />
              )}
            </div>

            {/* user login */}

            {user?.userType === 'student' && (
              <div>
                <a
                  ref={refs !== undefined ? refs[2].refValue : undefined}
                  rel='noopener noreferrer'
                  href={routes[0].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(routes[0].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip placement='rightTop' title={routes[0].title}>
                      <img src={routes[0].image} alt={routes[0].title} />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={routes[0].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {routes[0].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[3].refValue : undefined}
                  rel='noopener noreferrer'
                  href={routes[1].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(routes[1].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip placement='rightTop' title={routes[1].title}>
                      <img src={routes[1].image} alt={routes[1].title} />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={routes[1].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {routes[1].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[4].refValue : undefined}
                  rel='noopener noreferrer'
                  href={routes[2].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(routes[2].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip placement='rightTop' title={routes[2].title}>
                      <img src={routes[2].image} alt={routes[2].title} />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={routes[2].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {routes[2].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[5].refValue : undefined}
                  rel='noopener noreferrer'
                  href={routes[3].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(routes[3].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip placement='rightTop' title={routes[3].title}>
                      <img src={routes[3].image} alt={routes[3].title} />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={routes[3].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {routes[3].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[6].refValue : undefined}
                  rel='noopener noreferrer'
                  href={routes[4].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(routes[4].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip placement='rightTop' title={routes[4].title}>
                      <img src={routes[4].image} alt={routes[4].title} />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={routes[4].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {routes[4].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  // ref={refs !== undefined ? refs[7].refValue : undefined}
                  rel='noopener noreferrer'
                  href={routes[6].href}
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.assign(routes[6].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip placement='rightTop' title={routes[6].title}>
                      <img src={routes[6].image} alt={routes[6].title} />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={routes[6].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {routes[6].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[7].refValue : undefined}
                  rel='noopener noreferrer'
                  href={routes[5].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(routes[5].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip placement='rightTop' title={routes[5].title}>
                      <img src={routes[5].image} alt={routes[5].title} />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={routes[5].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {routes[5].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                {/* {
                routes.map((item, index) => (
                  <a
                    ref={refs.map((refItem: any) => refItem.belongsTo === item.title)[0]?.refValue}
                    key={`routes-${item.href}-${index}`}
                    rel="noopener noreferrer"
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault()
                      navigate(item.href)
                    }}
                    className="flex items-center ml-[2.2rem] mb-[2rem]">
                    <div>
                      <img src={item.image} alt={item.title} />
                    </div>

                    <span className={`ml-[0.7rem] text-appcolorwhite text-base`}>
                      {item.title}
                    </span>
                  </a>
                ))
              } */}
              </div>
            )}

            {user?.userType === 'teacher' && (
              <div>
                <a
                  ref={refs !== undefined ? refs[2].refValue : undefined}
                  rel='noopener noreferrer'
                  href={teacherRoutes[0].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(teacherRoutes[0].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip
                      placement='rightTop'
                      title={teacherRoutes[0].title}>
                      <img
                        src={teacherRoutes[0].image}
                        alt={teacherRoutes[0].title}
                      />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={teacherRoutes[0].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {teacherRoutes[0].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[3].refValue : undefined}
                  rel='noopener noreferrer'
                  href={teacherRoutes[1].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(teacherRoutes[1].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip
                      placement='rightTop'
                      title={teacherRoutes[1].title}>
                      <img
                        src={teacherRoutes[1].image}
                        alt={teacherRoutes[1].title}
                      />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={teacherRoutes[1].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {teacherRoutes[1].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[4].refValue : undefined}
                  rel='noopener noreferrer'
                  href={teacherRoutes[2].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(teacherRoutes[2].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip
                      placement='rightTop'
                      title={teacherRoutes[2].title}>
                      <img
                        src={teacherRoutes[2].image}
                        alt={teacherRoutes[2].title}
                      />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={teacherRoutes[2].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {teacherRoutes[2].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[5].refValue : undefined}
                  rel='noopener noreferrer'
                  href={teacherRoutes[3].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(teacherRoutes[3].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip
                      placement='rightTop'
                      title={teacherRoutes[3].title}>
                      <img
                        src={teacherRoutes[3].image}
                        alt={teacherRoutes[3].title}
                      />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={teacherRoutes[3].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {teacherRoutes[3].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  ref={refs !== undefined ? refs[6].refValue : undefined}
                  rel='noopener noreferrer'
                  href={teacherRoutes[4].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(teacherRoutes[4].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip
                      placement='rightTop'
                      title={teacherRoutes[4].title}>
                      <img
                        src={teacherRoutes[4].image}
                        alt={teacherRoutes[4].title}
                      />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={teacherRoutes[4].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {teacherRoutes[4].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                <a
                  // ref={refs !== undefined ? refs[7].refValue : undefined}
                  rel='noopener noreferrer'
                  href={teacherRoutes[5].href}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(teacherRoutes[5].href);
                  }}
                  className='mb-[2rem] ml-[2.2rem] flex items-center'>
                  <div>
                    <Tooltip
                      placement='rightTop'
                      title={teacherRoutes[5].title}>
                      <img
                        src={teacherRoutes[5].image}
                        alt={teacherRoutes[5].title}
                      />
                    </Tooltip>
                  </div>

                  {!collapseSideBar ? (
                    <Tooltip placement='rightTop' title={teacherRoutes[5].info}>
                      <span
                        className={`ml-[0.7rem] text-base text-appcolorwhite`}>
                        {teacherRoutes[5].title}
                      </span>
                    </Tooltip>
                  ) : null}
                </a>

                {/* <a
									ref={refs !== undefined ? refs[2].refValue : undefined}
									rel="noopener noreferrer"
									href={teacherRoutes[5].href}
									onClick={(e) => {
										e.preventDefault()
										navigate(teacherRoutes[5].href)
									}}
									className="flex items-center ml-[2.2rem] mb-[2rem]">
									<div>
										<Tooltip placement="rightTop" title={teacherRoutes[5].title}>
											<img src={teacherRoutes[5].image} alt={teacherRoutes[5].title} />
										</Tooltip>
									</div>


									{
										!collapseSideBar ?
											<span className={`ml-[0.7rem] text-appcolorwhite text-base`}>
												{teacherRoutes[5].title}
											</span>
											:
											null
									}
								</a> */}
              </div>
            )}

            {!collapseSideBar ? (
              <div className='custom-pink-bg-yellow-linear mx-auto mt-[2rem] flex w-[80%] cursor-pointer items-center justify-center rounded-[13px] py-[0.5rem]'>
                <div>
                  <img src='/img/vectors/share.svg' alt='share' />
                </div>
                <p className='text-base font-bold text-appcolorwhite'>
                  Invite Friends
                </p>
              </div>
            ) : null}

            {!collapseSideBar ? (
              <>
                {user?.aiTutorAssignmentId !== undefined &&
                user?.aiTutorDetails !== undefined ? (
                  <div className='absolute bottom-[1rem] left-8 right-10 rounded-2xl'>
                    <img
                      src={user?.aiTutorDetails?.headShot}
                      alt='ai'
                      className='h-[6rem] cursor-pointer rounded-2xl'
                      onClick={() => {
                        setShowAIOptions(!showAIOptions);
                      }}
                      ref={
                        refs !== undefined
                          ? findDashboardRef(refs, 'lily')
                          : undefined
                      }
                    />
                  </div>
                ) : null}
              </>
            ) : null}
          </div>
        </Sider>

        <Layout
          className='site-layout bg-appcolorwhite'
          style={{
            marginLeft: !collapseSideBar ? 225 : 100,
          }}>
          {showHeader ? (
            <Header
              style={{
                position: 'sticky',
                top: 0,
                zIndex: 100,
                width: '100%',
                background: '#ffffff',
                padding: '0 0 6rem 0',
              }}
              className='bg-[transparent]'>
              <div className='mt-[1.4rem] flex justify-between'>
                <div className='mr-8 flex flex-col gap-2 xl:mr-0 xl:flex-row xl:items-center'>
                  <p className='font-quicksand text-[27px] font-semibold leading-[34px] text-appcolorblackfaint'>
                    {location?.state?.pageName ?? 'Dashboard'}
                  </p>
                  <div className='flex items-center justify-center rounded-[14px] bg-appcolorgreyfaint px-[0.6rem] py-[0.4rem] xl:ml-[1.2rem]'>
                    <span className='mr-3  text-[15px] font-semibold leading-[19px] text-appcolorgreydeep'>
                      {moment().format('MMM Do, YY')}
                    </span>
                    <div>
                      <img src='/img/vectors/light.svg' alt='light' />
                    </div>
                  </div>
                </div>

                <div className='mr-12 flex items-center relative'>
                  <div
                    className='flex h-[3rem] items-center rounded-[15px] border-[2px]  border-solid border-appcolorgreyfaint bg-appcolorwhite px-[0.6rem] py-[0.7rem]'
                    onClick={() => {
                      setShowAppSearch(true);
                    }}>
                    <Input
                      size='small'
                      placeholder='Search...'
                      bordered={false}
                      className='custom-transparent-input-navbar-search mr-4 bg-appcolorwhite'
                    />
                    <div>
                      <img src='/img/vectors/search.svg' alt='search' />
                    </div>
                  </div>
                  <div className='ml-4 flex h-[3rem] rounded-[15px] bg-appcolorpurplefaint px-[1rem] pb-[0.5rem] pt-[1rem]'>
                    <div
                      id='mood-area'
                      className='hidden lg:block custom-piped-raised relative mt-2'>
                      <div className='mr-5 mt-[-1.8rem] lg:mr-0'>
                        <Select
                          placeholder='Select mood'
                          size='small'
                          bordered={false}
                          value='Light Mood'
                          className='custom-transparent-input-navbar-select'
                          //@ts-ignore
                          getPopupContainer={() =>
                            document.getElementById('mood-area')
                          }>
                          <Option value='Light Mood'>
                            <div className='flex items-center'>
                              <span>Light Mood</span>
                            </div>
                          </Option>
                        </Select>
                      </div>
                    </div>

                    {/* Conditional rendering for smaller screens (hamburger menu) */}
                    <div className='flex items-center lg:hidden'>
                      <img
                        src='/img/vectors/hamburger.svg'
                        className='h-8 w-8 cursor-pointer'
                        alt='menu icon'
                        onClick={toggleMenu}
                      />
                    </div>
                    {menuOpen && (
                      <div className='lg:hidden absolute top-20 right-0 flex h-[4rem] rounded-[15px] bg-appcolorpurplefaint px-[1rem] w-[400px] py-[1rem] items-center'>
                         <div
                      id='mood-area'
                      className='custom-piped-raised relative '>
                      <div className='mr-5 '>
                        <Select
                          placeholder='Select mood'
                          size='small'
                          bordered={false}
                          value='Light Mood'
                          className='custom-transparent-input-navbar-select'
                          //@ts-ignore
                          getPopupContainer={() =>
                            document.getElementById('mood-area')
                          }>
                          <Option value='Light Mood'>
                            <div className='flex items-center'>
                              <span>Light Mood</span>
                            </div>
                          </Option>
                        </Select>
                      </div>
                    </div>
                        <div className='lg:custom-piped line ml-[0.8rem] mt-2 flex items-center'>
                          <div className='mb-2 mr-[1rem] '>
                            <NotificationMenu />
                          </div>

                          <div className='mb-2 mr-[1rem]'>
                            <img
                              src='/img/vectors/settingsnav.svg'
                              alt='notification'
                              className='h-auto cursor-pointer'
                              onClick={() => {
                                navigate(
                                  `/${user?.userType}/dashboard/settings`
                                );
                              }}
                            />
                          </div>

                          <div className='mb-2 mr-[1rem]'>
                            <img
                              src='/img/vectors/question.svg'
                              alt='notification'
                              className='h-[1.1rem] w-[1.1rem] cursor-pointer'
                              onClick={() => {
                                dispatch(
                                  updateShowTourStart({
                                    showTourStart: true,
                                  })
                                );
                              }}
                            />
                          </div>

                          <div className='mb-2 mr-1'>
                            <img
                              src='/img/vectors/message.svg'
                              alt='notification'
                              className='h-[1.1rem] w-[1.1rem] cursor-pointer'
                              onClick={() => {
                                navigate(
                                  `/${user?.userType}/dashboard/messaging`
                                );
                              }}
                            />
                          </div>
                        </div>

                        <div className='ml-3'>
                          <Dropdown menu={{ items }} placement='bottom' arrow>
                            <div className='flex cursor-pointer items-center'>
                              <div>
                                <img
                                  src={`${
                                    user?.userAvatarURL === undefined
                                      ? '/img/vectors/usertag.svg'
                                      : user?.userAvatarURL === ''
                                      ? '/img/vectors/usertag.svg'
                                      : user?.userAvatarURL
                                  }`}
                                  alt='usertag'
                                  className='h-[1.25rem] w-[1.25rem]'
                                />
                              </div>
                              <div className='ml-3'>
                                <img
                                  src='/img/vectors/caretdown.svg'
                                  alt='caretdown'
                                />
                              </div>
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                    )}

                    {/* Conditional rendering for larger screens */}
                    <div className='hidden lg:flex'>
                      {/* Notification block */}
                      <div className='md:custom-piped line ml-[0.8rem] mt-2 flex items-center'>
                        <div className='mb-2 mr-[1rem] '>
                          <NotificationMenu />
                        </div>

                        <div className='mb-2 mr-[1rem]'>
                          <img
                            src='/img/vectors/settingsnav.svg'
                            alt='notification'
                            className='h-[1.1rem] w-[1.1rem] cursor-pointer'
                            onClick={() => {
                              navigate(`/${user?.userType}/dashboard/settings`);
                            }}
                          />
                        </div>

                        <div className='mb-2 mr-[1rem]'>
                          <img
                            src='/img/vectors/question.svg'
                            alt='notification'
                            className='h-[1.1rem] w-[1.1rem] cursor-pointer'
                            onClick={() => {
                              dispatch(
                                updateShowTourStart({
                                  showTourStart: true,
                                })
                              );
                            }}
                          />
                        </div>

                        <div className='mb-2 mr-1'>
                          <img
                            src='/img/vectors/message.svg'
                            alt='notification'
                            className='h-[1.1rem] w-[1.1rem] cursor-pointer'
                            onClick={() => {
                              navigate(
                                `/${user?.userType}/dashboard/messaging`
                              );
                            }}
                          />
                        </div>
                      </div>

                      <div className='ml-3'>
                        <Dropdown menu={{ items }} placement='bottom' arrow>
                          <div className='flex cursor-pointer items-center'>
                            <div>
                              <img
                                src={`${
                                  user?.userAvatarURL === undefined
                                    ? '/img/vectors/usertag.svg'
                                    : user?.userAvatarURL === ''
                                    ? '/img/vectors/usertag.svg'
                                    : user?.userAvatarURL
                                }`}
                                alt='usertag'
                                className='h-[1.25rem] w-[1.25rem]'
                              />
                            </div>
                            <div className='ml-3'>
                              <img
                                src='/img/vectors/caretdown.svg'
                                alt='caretdown'
                              />
                            </div>
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Header>
          ) : null}

          <Content
            style={{
              margin: showHeader ? '24px 0px 0' : '0px 0px 0',
              overflow: 'initial',
              paddingLeft: '1rem',
            }}
            className='relative bg-appcolorwhite'>
            <div
              style={{
                padding: '0',
                overflow: 'hidden',
                position: 'relative',
              }}>
              {children}
            </div>

            {showReviewModal ? (
              <Reviewmodal open={true} closeModal={closeReviewModal} />
            ) : null}
          </Content>
        </Layout>
      </Layout>

      {showAIAlert ? (
        <Aialerts
          open={showAIAlert}
          closeModal={closeAIAlert}
          alertType={aiAlertType}
          title={aiAlertMessage.title}
          description={aiAlertMessage.description}
          actionFunc={() => {
            closeAIAlert();
          }}
          actionText='Okay'
          // extraActionText="Do it later"
          // extraActionFunc={() => {
          //   setShowAIAlert(false);
          // }}
        />
      ) : null}
    </div>
  );
};

Dashboardpages.defaultProps = {
  showHeader: true,
};

export default Dashboardpages;
